import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App bg-ivory">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main id="main" className="pt-[72px] md:pt-[80px]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            classNames: {
              toast: "rounded-xl border border-line bg-white text-charcoal",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
